import React from "react";
import { useEffect, useState } from "react";
import FootballLeagueTeamStats from "./FootballLeagueTeamStats";
import FootballLeaguePlayerStats from "./FootballLeaguePlayerStats";
import { loadStyles } from "../../../utils/cssLoader";

const FootballLeagueStats = ({
  dictionary,
  data,
  loadCSS,
  websiteBaseUrl,
  dataPath,
  dataClient = false,
}) => {
  const [clientData, setClientData] = useState(null);
  const [active, setActive] = useState("team");

  const tabs = [
    { key: "team", label: "Team Stats" },
    { key: "player", label: "Player Stats" },
  ];

  // Load client-side data if needed
  useEffect(() => {
    if (!dataClient) return;

    const raw = document
      .querySelector(".microservice-cont")
      ?.getAttribute("data-listingdata");

    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  // Load CSS dynamically
  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("leagueStats");
    }
  }, [loadCSS]);

  const statsOverview = dataClient ? clientData?.overview : data?.overview;
  const topScorer = dataClient ? clientData?.topScorers : data?.topScorers;
  const topAssists = dataClient ? clientData?.topAssists : data?.topAssists;

  if (dataClient && !clientData) return null;

  return (
    <>
      <nav className="inner_tab">
        <ul>
          {tabs.map(({ key, label }) => (
            <li
              key={key}
              className={active === key ? "active" : ""}
              onClick={() => setActive(key)}
              data-name={key}
            >
              <button>{label}</button>
            </li>
          ))}
        </ul>
      </nav>

      {active === "team" ? (
        <FootballLeagueTeamStats
          data={statsOverview?.data}
          dictionary={dictionary}
        />
      ) : (
        <FootballLeaguePlayerStats
          topScorer={topScorer?.data}
          topAssists={topAssists?.data}
          dictionary={dictionary}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          dataClient={dataClient}
        />
      )}
    </>
  );
};

export default FootballLeagueStats;
